import Layout from "@/layouts/layout";
import IdvVerificationAlert from "@/components/IdvVerificationAlert";
import PageHeading from "@/components/layout/PageHeading";
import ProjectList from "@/components/projects/ProjectList";
import HackatimeConnect from "@/components/projects/HackatimeConnect";
import Panel from "@/components/ui/Panel";
import { ButtonLink } from "@/components/ui/Button";
import { usePage } from "@inertiajs/react";
import type { SharedProps } from "@/types";

import type { Project } from "@/interfaces/project";

interface Props {
  projects: Project[];
  // Worked out server-side: projects belong to a Boba Bash, so whether someone
  // may open one depends on the events they staff, not on a flag the page can
  // read off the user.
  can_create: boolean;
  creation_blocked_reason: string | null;
}

export default function Index({
  projects,
  can_create,
  creation_blocked_reason,
}: Props) {
  const { props } = usePage<SharedProps>();
  const rate = (props.program.budget_per_hour_cents / 100).toFixed(2);

  return (
    <Layout>
      <div className="flex flex-col gap-8">
        <PageHeading
          title="Projects"
          subtitle={`Build something, ship it, and every hour a reviewer approves adds $${rate} to your event's budget.`}
          actions={
            can_create ? (
              <ButtonLink href="/projects/new">New project</ButtonLink>
            ) : undefined
          }
        />

        <HackatimeConnect />

        <IdvVerificationAlert />

        {creation_blocked_reason && (
          <Panel title="notice.txt" tone="alt">
            <p className="text-body text-ink-muted">
              {creation_blocked_reason}
            </p>
          </Panel>
        )}

        <ProjectList projects={projects} canCreate={can_create} />
      </div>
    </Layout>
  );
}
